import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { formatCount } from "./useAnimatedCount";

const SERVICES = ["API Gateway", "Odoo Connector", "Token Service", "Auth Service"];

const HomeSystemStatus = ({ usageCount, tokenBalance }) => {
  const { t } = useTranslation("common");
  const totalTokens = Math.max(tokenBalance, 0);
  const used = Math.max(usageCount, 0);
  const pct = totalTokens > 0 ? Math.min((used / totalTokens) * 100, 100) : 0;

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <div className="card-title">{t("System Status")}</div>
          <div className="card-subtitle">{t("All services operational")}</div>
        </div>
        <span className="status-badge">
          ● {t("All Systems Go")}
        </span>
      </div>
      <div className="status-list">
        {SERVICES.map((service) => (
          <div key={service} className="status-row">
            <span className="name">{t(service)}</span>
            <span className="state">{t("Operational")}</span>
          </div>
        ))}
        <div className="usage-box">
          <div className="usage-label">{t("Token usage this month")}</div>
          <div className="usage-bar-track">
            <div className="usage-bar-fill" style={{ width: `${pct}%` }} />
          </div>
          <div className="usage-meta">
            <span>
              {formatCount(used)} / {formatCount(totalTokens)} {t("tokens used")}
            </span>
            <span className="pct">{pct.toFixed(2)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

HomeSystemStatus.propTypes = {
  usageCount: PropTypes.number.isRequired,
  tokenBalance: PropTypes.number.isRequired
};

export default HomeSystemStatus;
